export default __webpack_public_path__ + "static/media/open_eye.8695d1c7.svg";